import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { StickyWrapperComponent } from "@hermes/aphrodite/sticky-wrapper";

import { ApplePayModule } from "@hermes/fragments/apple-pay";
import { CallToActionAddToCartModule } from "@hermes/fragments/call-to-action-add-to-cart";
import { CallToActionNotifyMeModule } from "@hermes/fragments/call-to-action-notify-me";
import { CallToActionRegisterYourInterestModule } from "@hermes/fragments/call-to-action-register-your-interest";
import { ProductAddToCartServiceModule } from "@hermes/fragments/product-add-to-cart";
import { AddToCartStateModule } from "@hermes/states/add-to-cart";
import { ApplePayStateModule } from "@hermes/states/apple-pay";

import { CallToActionPurchaseComponent } from "./components/call-to-action-purchase/call-to-action-purchase.component";

@NgModule({
    imports: [
        CommonModule,
        AddToCartStateModule,
        CallToActionComponent,
        MessageBlockComponent,
        StickyWrapperComponent,
        ApplePayModule,
        ApplePayStateModule,
        CallToActionAddToCartModule,
        CallToActionNotifyMeModule,
        CallToActionRegisterYourInterestModule,
        ProductAddToCartServiceModule,
    ],
    declarations: [CallToActionPurchaseComponent],
    exports: [CallToActionPurchaseComponent],
})
export class CallToActionPurchaseModule {}
